import { NavLink } from "react-router-dom";
import React from "react";
import styled from "styled-components";
import Navbar from "./Navbar";

// Main container for the Header section
const MainHeader = styled.header`
  width: 100%;
  height: 70px;
  background-color: #171764;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 2rem;
  position: fixed; /* Fix the header at the top */
  top: 0; /* Keep it at the top */
  left: 0;
  z-index: 10; /* Make sure the header stays on top of other elements */
`;

// Add margin-top to the body or main container to avoid overlap with the fixed header
const MainContainer = styled.div`
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  width: 100%;
  padding-top: 70px; /* Space for the fixed header */
`;

// Header text styling
const NavHeader = styled.h1`
  font-size: 30px;
  color: #fff;
  text-align: center;
  background: linear-gradient(to right, #1010b2, #1e3c72); /* Blue Gradient */
  padding: 20px;
  border-radius: 10px;
  margin: 0;
  transition: all 0.3s ease-in-out;

  /* Hover effect for better appearance */
  &:hover {
    background: linear-gradient(to right, #2a5298, #1e3c72);
    cursor: pointer;
  }

  /* Responsive design for smaller screens */
  @media (max-width: 768px) {
    font-size: 24px;
    padding: 15px;
  }

  @media (max-width: 480px) {
    font-size: 20px;
    padding: 10px;
  }
`;

// Styled link that wraps the header text
const StyledLink = styled(NavLink)`
  text-decoration: none;
`;

const Header = () => {
  return (
    <>
      <MainContainer>
        <MainHeader>
          <StyledLink to="/">
            <NavHeader>ZoFinds</NavHeader>
          </StyledLink>
          <Navbar />
        </MainHeader>
      </MainContainer>
    </>
  );
};

export default Header;
